const AdminActionTypes = {
  SET_TEACHER: "SET_TEACHER",
  SET_ALL_USERS: "SET_ALL_USERS",
  UPDATE_SEARCH_STATUS: "UPDATE_SEARCH_STATUS",
  UPDATE_TEACHER_LEVEL: "UPDATE_TEACHER_LEVEL",

  UPDATE_CURRENT_COLLEGE_DETAILS: "UPDATE_CURRENT_COLLEGE_DETAILS",

  // for AllColleges page - lieh
  SET_CUSTOMER: "SET_CUSTOMER",
  SET_ALL_CUSTOMERS: "SET_ALL_CUSTOMERS",
  UPDATE_CUSTOMER_SEARCH_STATUS: "UPDATE_CUSTOMER_SEARCH_STATUS"
}

export default AdminActionTypes
